module.exports = __webpack_public_path__ + "img/file-alt-solid.cfcbe4b4.svg";